import { InstanceInfo } from "app/types-shared";
import { ApplicationState } from "app/types-store";
import { useSelector } from "react-redux";

const getTenant = (instanceInfo: InstanceInfo): string | undefined => {
  return instanceInfo ? `${instanceInfo.envType}${instanceInfo.tenantId}` : undefined;
};

const useInstanceInfo = () =>
  useSelector(
    (state: ApplicationState) => state?.app?.instanceInfo
  );

const useAiChatAssistantState = () =>
  useSelector(
    (state: ApplicationState) => state?.aiChatAssistant
  );

export const useAiChatAssistantAccessInfo = () =>
  useSelector(
    (state: ApplicationState) => state?.app?.aiChatAssistantAccessInfo
  );

export const useDraftSavingState = () =>
  useSelector(
    (state: ApplicationState) => state?.caseArea?.editing?.saving
  );

export function useAiChatAssistantSelectors(aiChatFeatureFlag?: string) {
  const accessInfo = useAiChatAssistantAccessInfo() ?? {
    chatAssistant: false,
    fiveWhys: false,
    caseDraftCreation: false
  };
  const {
    chatAssistant = false,
    fiveWhys = false,
    caseDraftCreation = false
  } = accessInfo;
  const aiChatFeature = aiChatFeatureFlag ? (accessInfo[aiChatFeatureFlag] ?? false) : false;
  const instanceInfo = useInstanceInfo();
  const aiChatAssistantState = useAiChatAssistantState();
  const tenant = getTenant(instanceInfo);

  return {
    enableChatAssistant: chatAssistant ?? false,
    enableFiveWhys: fiveWhys ?? false,
    caseDraftCreation,
    aiChatFeature: aiChatFeature,
    tenant,
    running: aiChatAssistantState?.running ?? false,
    createDraft: aiChatAssistantState?.createDraft ?? false,
    updateDraft: aiChatAssistantState?.updateDraft ?? false,
    saveDraft: useDraftSavingState()
  };
}
